import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  getAllSpecialtiesList: [],
  getSpecialtyById: {},
  dropdownSpecialties: [],
  generatedScript: {},
  generatedScriptLoading: false,
};

const specialtySlice = createSlice({
  name: 'specialtySlice',
  initialState,
  reducers: {
    getAllSpecialtiesListSlice: (state, { payload }) => {
      state.getAllSpecialtiesList = payload;
    },
    getAllSpecialtyByIdSlice: (state, { payload }) => {
      state.getSpecialtyById = payload;
    },
    getAllSpecialtiesDropdownSlice: (state, { payload }) => {
      state.dropdownSpecialties = payload;
    },
    getGeneratedScriptSlice: (state, { payload }) => {
      state.generatedScript = payload;
    },
    getGeneratedScriptLoadingSlice: (state, { payload }) => {
      state.generatedScriptLoading = payload;
    },
  },
});

const { actions, reducer } = specialtySlice;

export const {
  getAllSpecialtiesListSlice,
  getAllSpecialtyByIdSlice,
  getAllSpecialtiesDropdownSlice,
  getGeneratedScriptSlice,
  getGeneratedScriptLoadingSlice,
} = actions;

export default reducer;
